export default {
  default: {
    title: "An Awesome Place",
    address: "397 North End Road Fulham SW6 1NR",
    website: "https://joeandcoburgers.co.uk",
    map: "https://g.page/joeandcoburgers?share",
  },
  "Shopping_-_X6073_Y3646": {
    title: "Fulham Broadway Shopping Centre",
    category: "Shopping Centre in the heart of Fulham Broadway",
    address: "Fulham Rd,<br/> London SW6 1BW",
    map: "https://goo.gl/maps/i3B83Vy1kB9ouFgZ9",
    website: "https://fulhambroadway.co.uk/shopping/",
  },
  Crystals_X3170_Y4494: {
    title: "Crystals",
    category: "High Quality Jewelry Specialist",
    address: "627 Fulham Rd,<br/> London SW6 5UQ",
    map: "https://goo.gl/maps/KMubwRmUzt73ZsqLA",
    website: "https://crystalys-jewelry-store.business.site",
  },
  Dentist_X2653_Y1976: {
    title: "NHS Dentist",
    category: "Established NHS Dental Practice",
    address: "355 North End Rd,<br/> London SW6 1NW",
    map: "https://goo.gl/maps/mWZLzaRhwF1HYQ5T8",
    website: "https://www.nhsdentist.com",
  },
  Greek_X4136_Y3640: {
    title: "Kalamaki Street Greek",
    category: "Greek Street Food Made By The Gods",
    address: "49 Fulham Broadway,<br/> London SW6 1AE",
    map: "https://g.page/streetgreekfulham?share",
    website: "https://streetgreek.co.uk",
  },
  Dance_X2072_Y2783: {
    title: "Dance Attic Studios",
    category: "Dance & Rehearsal Studios",
    address: "368 North End Rd,<br/> London SW6 1LY",
    map: "https://goo.gl/maps/n1MBGikthTvLh7wL7",
    website: "https://www.danceattic.com",
  },
  Bodeans_X4445_Y4314: {
    title: "Bodean’s BBQ",
    category: "Kansas City Style BBQ",
    address: "4, Broadway Chambers,<br/> Fulham Broadway,<br/> London SW6 1EP",
    map: "https://g.page/bodean-s-bbq-fulham?share",
    website: "http://bodeansbbq.com",
  },
  Car_X6518_Y4701: {
    title: "Fulham & Chelsea Cars",
    category: "24 Hour Taxi and Minicab Services",
    address: "4 Harwood Road,<br/> Fulham Broadway,<br/> London SW6 4PH",
    map: "https://g.page/fulham-chelsea-cars?share",
    website: "https://www.fulhamchelseacars.co.uk",
  },
  Orange_X3495_Y2754: {
    title: "Orangetheory Fitness",
    category: "Total-Body Group Workouts",
    address: "24-32 Vanston Pl,<br/> London SW6 1AX",
    map: "https://goo.gl/maps/xyiDsVGQdtCDvjeJ7",
    website:
      "https://www.orangetheory.com/en-gb/locations/region-of-england/london/palace-street/",
  },
  Prince_X4544_Y400: {
    title: "The Prince",
    category: "A Grand Old Pub Brought Back To Life",
    address: "14 Lillie Rd,<br/> London SW6 1TT",
    map: "https://g.page/ThePrinceWestBrompton?share",
    website: "https://www.theprincelondon.com/",
  },
  Pedal_X3853_Y637: {
    title: "Pedal Back Cycling",
    category: "Bike Repairs & Coffee Shop",
    address: "24 Lillie Rd,<br/> London SW6 1TS",
    map: "https://g.page/pedalbackcycling?share",
    website: "https://www.pedalbackcycling.com",
  },
  Cock_X2639_Y3193: {
    title: "Cock Tavern",
    category: "Quirky Young Pub",
    address: "360 North End Rd,<br/> London SW6 1LY",
    map: "https://g.page/CockTavernFulham?share",
    website: "https://cocktavern.co.uk",
  },
  Foxden_X2971_Y3786: {
    title: "Foxden",
    category: "British Burger Restaurant",
    address: "24 Jerdan Pl,<br/> London SW6 1BH",
    map: "https://g.page/FoxdenLondon?share",
    website: "https://www.foxdenrestaurant.co.uk",
  },
  Jaffa_X2876_Y2402: {
    title: "Jaffa Bake House",
    category: "Multicultural Cuisine",
    address: "381 North End Rd,<br/> London SW6 1NP",
    map: "https://goo.gl/maps/UrgVbo4NFobtkJNN6",
    website: "https://www.instagram.com/jaffa_bake_house_/",
  },
  Fish_X3447_Y3877: {
    title: "The Fish & Chip Shack",
    category: "Family-run Fish & Chip Shack",
    address: "11 Fulham Broadway,<br/> London SW6 1AA",
    map: "https://goo.gl/maps/ye16eLaWnFtiWxPu6",
    website: "https://thefishandchipshack.com",
  },
  F45_X2448_Y3983: {
    title: "F45 Training Fulham",
    category: "45 Minute Training Classes",
    address: "2-8 Dawes Rd,<br/> London SW6 7EW",
    map: "https://g.page/f45fulham?share",
    website: "https://f45training.co.uk/fulham/home",
  },
  Grill_X4670_Y3665: {
    title: "Broadway Bar and Grill",
    category: "Sports, Events, Drinks, Roof Terrace",
    address: "474, 476 Fulham Rd,<br/> London SW6 1BY",
    map: "https://g.page/fulhambroadwaybar?share",
    website: "https://www.fulhambroadwaybar.co.uk",
  },
  Holiday_X2449_Y762: {
    title: "Holiday Inn Express",
    category: "A smart west London hotel",
    address: "295 North End Rd,<br/> London W14 9NS",
    map: "https://goo.gl/maps/Un3d8DdisHbxUThj7",
    website: "http://tiny.cc/6xn9uz",
  },
  Rylston_X730_Y2455: {
    title: "The Rylston",
    category: "Lively and Upbeat Pub",
    address: "197 Lillie Rd,<br/> London SW6 7LW",
    map: "https://goo.gl/maps/w7hE5wSza5dMxNnU9",
    website: "http://www.therylston.com",
  },
  Drakes_X3486_Y3294: [
    {
      title: "Drakes",
      category: "Highly Skilled Mens Haircuts",
      address: "19 Jerdan Pl,<br/> London SW6 1BE",
      map: "https://g.page/DrakesOfLondon?share",
      website: "https://www.drakesoflondon.com",
    },
    {
      title: "Becky Blooms",
      category: "Freshly Cut Flowers, Bouquets & Plants",
      address: "19 Jerdan Pl,<br/> London SW6 1BE",
      map: "https://g.page/BeckyBlooms?share",
      website: "https://www.facebook.com/BeckyBloomsFlowers",
    },
  ],
  Spa_X1803_Y4759: {
    title: "Spa Clinique",
    category: "Beauty and Skin Experts",
    address: "580 Fulham Rd,<br/> London SW6 5NT",
    map: "https://g.page/spa-clinique-london?share",
    website: "http://www.spaclinique.co.uk",
  },
  Arthill_X727_Y877: {
    title: "Arthill Gallery",
    category: "Fine Art, Fashion, and Interior Design",
    address:
      "Ground Floor, Lourdes Apartments,<br/> North End Road, London W14 9NU",
    map: "https://goo.gl/maps/xWf6uHFqLaeFCtDi6",
    website: "http://www.arthillgallery.com",
  },
  Opal_X2538_Y4852: {
    title: "Opal Spa and Nail Salon",
    category: "Professional Nail Care For All",
    address: "655 Fulham Rd,<br/> London SW6 5PY",
    map: "https://goo.gl/maps/dYpwsKkt9KyJCKLZ7",
    website: "https://www.opalsalon.co.uk",
  },
  Cake_X3038_Y2825: {
    title: "Cake Addict",
    category: "Delicious and Addicting Cakes!",
    address: "391 North End Rd,<br/> London SW6 1NR",
    map: "https://g.page/the-cake-addict?share",
    website: "https://thecakeaddict.co.uk/",
  },
  Nexus_X7369_Y3747: {
    title: "Nexus",
    category: "Incredible Dining Experience",
    address: "450 Fulham Rd,<br/> London SW6 1DL",
    map: "https://g.page/NexusFulhamLondon?share",
    website: "https://nexusfulham.com",
  },
  Greenbay_X1423_Y1324: {
    title: "Greenbay",
    category: "100% Vegan Supermarket",
    address: "Bramber Court,<br/> 228 North End Rd,<br/> London W14 9NU",
    map: "https://g.page/greenbay_uk?share",
    website: "https://www.greenbaysupermarket.co.uk",
  },
  Chelsea_X7257_Y3077: {
    title: "Chelsea FC",
    category: "The Champions of Europe",
    address: "Stamford Bridge,<br/> Fulham Rd, London<br/> SW6 1HS",
    map: "https://goo.gl/maps/oYQYGrC9TPpbBGyWA",
    website: "https://www.chelseafc.com/en",
  },
  Fouberts_X1433_Y3578: {
    title: "Foubert's",
    category: "Italian Diner & Gelateria",
    address: "2 Vanston Pl,<br/> London SW6 1AY",
    map: "https://g.page/fouberts-fulham?share",
    website: "https://www.fouberts.co.uk/fulham",
  },
  Puregym_X4422_Y3112: {
    title: "PureGym",
    category: "Contract-Free Gym",
    address: "25 Jerdan Pl,<br/> London SW6 1BE",
    map: "https://goo.gl/maps/MUDPQ5zaWNCSyMp3A",
    website: "https://www.puregym.com/gyms/london-fulham/",
  },
  "01ElegantNails_X2374_Y1488": {
    title: "Elegant Nails",
    category: "Nail Service For Any Occasion",
    address: "86B Lillie Rd,<br/> London SW6 1TL",
    map: "https://goo.gl/maps/6GRKVRNQRuDibLtc9",
    website: "https://www.facebook.com/Elegantnailsfulham/",
  },
};
